import React from 'react'
import { Link } from 'react-router-dom'

export default function BotonContactar() {
    return (
        <>
            <div className="contact_btn_home">
                <div className="btn btn-primary text-uppercase btn_contact_home">
                    <a href="/contacto" style={{
                        color: "#161f6e",
                        textDecoration: "none",
                        fontWeight: "bold"
                    }}>Contacto</a>
                </div>
            </div>
        </>
    )
}
